import { useCallback } from 'react'

import { isValid, parseISO } from 'date-fns'

import useLanguage from 'hooks/useLanguage'

type Formats = 'ddMM' | 'ddMMyyyy' | 'ddMMyy'
type DateFormatsType = Record<Formats, Record<string, string>>
const dateFormats: DateFormatsType = {
  ddMM: { month: 'numeric', day: 'numeric' },
  ddMMyyyy: { month: 'numeric', day: 'numeric', year: 'numeric' },
  ddMMyy: { month: 'numeric', day: 'numeric', year: '2-digit' },
}

export default function useFormatDate() {
  const locale = useLanguage()
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return useCallback(
    (value?: string | null, params: { dateFormat?: Formats; withTime?: boolean } = {}) => {
      const { dateFormat = 'ddMMyy', withTime = false } = params

      if (!value) {
        return ''
      }
      const options: Intl.DateTimeFormatOptions | undefined = {
        ...dateFormats[dateFormat],
        ...(withTime && {
          hour: 'numeric',
          minute: 'numeric',
          timeZone: clientTimeZone,
        }),
      }
      const formatter = new Intl.DateTimeFormat(locale, options)
      const parsed = parseISO(value)
      return isValid(parsed) ? formatter.format(parsed) : ''
    },
    [locale, clientTimeZone],
  )
}
